import * as React from 'react';
import { Main } from './main';

const PreLoaderComponent = ({ dispatch, loading }: any) => {
  return <Main dispatch={dispatch} loading={loading} />;
};

export const PreLoader = React.memo(PreLoaderComponent);
